var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwStep6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0602 61.2387V30.2857C65.0602 17.5245 54.6151 7.07935 41.8539 7.07935H27.3499C14.5887 7.07935 4.14355 17.5245 4.14355 30.2857V61.2387C4.14355 61.5648 4.1548 61.8796 4.16604 62.2057H65.049C65.049 61.8796 65.0602 61.5648 65.0602 61.2387Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13281 62.2057H18.6368C18.6368 62.2057 14.7691 54.4703 14.7691 46.7348C14.7691 38.9994 14.7691 34.1647 14.7691 34.1647C14.7691 34.1647 22.5045 25.4623 24.4384 20.6277C26.3722 15.793 27.3392 10.9584 27.3392 10.9584L24.4384 7.09064C24.4384 7.09064 10.9013 10.9584 8.00054 16.7599C5.09974 22.5615 4.13281 29.3301 4.13281 29.3301V62.2057Z",
    fill: "#63C7C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0276 62.2057H51.5237C51.5237 62.2057 54.4245 55.4372 54.4245 47.7017C54.4245 39.9663 55.3914 34.1647 55.3914 34.1647C55.3914 34.1647 47.6559 25.4623 45.7221 20.6277C43.7882 15.793 42.8213 10.9584 42.8213 10.9584L45.7221 7.09064C45.7221 7.09064 59.2591 10.9584 62.1599 16.7599C65.0607 22.5615 66.0276 29.3301 66.0276 29.3301V62.2057Z",
    fill: "#63C7C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92969 61.9471V29.5661C3.92969 24.2817 6.0322 19.166 9.89993 15.0284C13.7677 10.9021 19.1645 8.00131 25.2134 6.80951",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.136 11.6554C27.136 11.6554 26.4389 29.7685 3.92969 40.6746",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4344 61.9471C15.5674 53.0311 14.2631 43.4742 14.6229 33.8948",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8248 61.9471V29.5661C65.8248 24.2817 63.7222 19.166 59.8545 15.0284C55.9868 10.9021 50.59 8.00131 44.541 6.80951",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6074 11.6554C42.6074 11.6554 43.3045 29.7685 65.8138 40.6746",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3213 61.9471C54.1884 53.0311 55.4926 43.4742 55.1328 33.8948",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0293 62.588H49.3871",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3867 62.588H68.7253",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6631 8.49604C26.1803 9.56416 26.9111 10.4299 27.5633 11.1382C28.7438 12.4425 30.093 13.6005 31.386 14.7249C32.0831 15.3208 32.7802 15.9279 33.4548 16.5575C33.8933 16.9736 34.3768 17.1759 34.8715 17.1759C35.3662 17.1759 35.8609 16.9736 36.3331 16.5463C37.6261 15.3882 38.9078 14.2414 40.1896 13.0833C41.5275 11.8691 42.5057 10.8122 43.304 9.73281C44.2597 8.42858 44.6644 7.00067 44.5183 5.47157C44.3609 3.84128 43.5514 2.59326 42.1797 1.86244C39.7174 0.558209 36.8166 0.816808 34.8377 2.4471C33.3199 1.18784 31.4085 0.749347 29.2947 1.22157C27.7769 1.54763 26.675 2.23347 25.9442 3.29035C25.5394 3.87501 25.3708 4.50464 25.2359 4.99935L25.2021 6.88824L25.2584 7.24802C25.3371 7.61906 25.4495 8.05755 25.6631 8.49604Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep6);
export default __webpack_public_path__ + "static/media/ww-step6.895144d0.svg";
export { ForwardRef as ReactComponent };